module.exports = __webpack_public_path__ + "img/bg2.3dc677e0.png";